import { http, HttpResponse, delay } from "msw";

const suppliers = [
    {
        "id": "f7f1b239-77c8-4fa1-88d6-3174596813e5",
        "name": "Auto Partes del Norte"
    },
    {
        "id": "3c180f6a-681a-4a8a-807e-029dcaf55ba7",
        "name": "Distribuidora Mecánica MX"
    },
    {
        "id": "b46e7372-0c52-41ad-b0c9-8c2c96e797e7",
        "name": "Refacciones González"
    }
];

const baseUrl = `${process.env.REACT_APP_API_URL}${process.env.REACT_APP_STAGE_ENV}/suppliers`

export const suppliersHandlers = [
    http.get(`${baseUrl}`, async ({ request }) => {
        await delay(2100);

        return HttpResponse.json(
            suppliers,
            { status: 200 }
        );
    })
];
